import { render, staticRenderFns } from "./AddEditForm.vue?vue&type=template&id=bd03d192"
import script from "./AddEditForm.vue?vue&type=script&lang=js"
export * from "./AddEditForm.vue?vue&type=script&lang=js"
import style0 from "./AddEditForm.vue?vue&type=style&index=0&id=bd03d192&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports